<div class="input-toggle-dropdown">

  @if (!inputToggleDropdownConfiguration.hideSwitch) {
    <app-switch-button
      [switchButtonConfiguration]="inputToggleDropdownConfiguration.toggleButtonConfiguration"
      [switchButtonModel]="switchButtonModel"
      (switch)="toggleInputDropdownHandler($event)"
      data-cy="input-toggle-dropdown-switch">
    </app-switch-button>
  }

  <app-input-dropdown
    #inputDropdown
    (inputStateChange)="manageInputStateChange($event)"
    (inputValueChange)="manageInputValueChange($event)"
    [initialValue]="state.initialReferenceData"
    [inputFormatter]="typeahead.inputTextNameFormatter"
    [resultFormatter]="typeahead.inputTextNameFormatter"
    [resultsFunction]="searchFunction"
    [alternateBackground]="true"
    [showViewMode]="inputToggleDropdownModel.viewMode"
    [messages]="inputToggleDropdownMessages"
    [dropdownTextOptionsNotBold]="true"
    [baseCypressTag]="inputToggleDropdownDataCy(inputToggleDropdownConfiguration.code)"
    placeholder="{{inputDropdownPlaceholder}}"
  class="input-dropdown"></app-input-dropdown>
</div>

